import { RoadmapFeature } from "../types.ts";

export interface FeatureDescriptionProps {
    content: RoadmapFeature["description"];
}

export const FeatureDescription = (props: FeatureDescriptionProps) => {
    // todo: GWP-9601
    return <p>{props.content.json.content[0]?.content[0]?.value}</p>;
};
